module.exports = __webpack_public_path__ + "assets/img/banner-cpa.2c116a76.webp";